import {
  TemplateRangeTier,
  templateRangeTiersApi,
} from '@texas/api/endpoints/metadata/templateRangeTiersApi';
import { VerifyDialogWithRequest } from '@texas/components/shared/dialog/VerifyDialogWithRequest';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import { useTranslation } from 'react-i18next';

interface ArchiveVdcTierProps extends SharedDisclosureProps {
  onArchive: () => void;
  tier: TemplateRangeTier;
}

export function ArchiveVdcTier({
  isOpen,
  tier,
  onArchive,
  onClose,
}: ArchiveVdcTierProps) {
  const { t } = useTranslation();
  return (
    <VerifyDialogWithRequest
      headerTitle={t('configuration.archiveVdcTier', {
        range: `${tier.startRange}-${tier.endRange}`,
      })}
      secondaryButtonTitle={t('general.cancel')}
      primaryButtonTitle={t('general.confirm')}
      primaryRequest={templateRangeTiersApi.archive}
      args={[tier.id]}
      isOpen={isOpen}
      onClose={onClose}
      onPerformed={onArchive}
      onSuccessTitle={t('general.archived')}
    >
      {t('alert.areYouSure')}
    </VerifyDialogWithRequest>
  );
}
